import { render, staticRenderFns } from "./FolderSelectModal.vue?vue&type=template&id=89d51bb0"
import script from "./FolderSelectModal.vue?vue&type=script&lang=js"
export * from "./FolderSelectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports